import PropTypes from 'prop-types'
import { useSelector, shallowEqual } from 'react-redux'
import { Checkmark } from '@leroy-merlin-br/backyard-react-icons'

import { Selectors } from 'checkout/redux/modules/associatedProducts'

import * as S from './styled'

const Plus = () =>
  <svg width="12" height="13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.5V.4H5.1v5.1H0v1.9l5.1-.1v5.1h1.8V7.3H12V5.5H7z"/></svg>

const ButtonComponent = ({
  onAddToCartClick,
  id
}) => {
  const {
    wasAdded = false,
    isLoading = false
  } = useSelector(state => Selectors.putStatusProductById(state, id), shallowEqual)

  const Icon = () => {
    if (wasAdded) {
      return (<Checkmark />)
    }

    return (<Plus />)
  }

  return (
    <S.Button
      variant="outline"
      size="kilo"
      isLoading={isLoading}
      onClick={() => !wasAdded && !isLoading && onAddToCartClick()}
      isStretch
      isDisabled={wasAdded}
    >
      <Icon />
      { wasAdded ? 'Produto adicionado' : 'Adicionar produto' }
    </S.Button>
  )
}

ButtonComponent.propTypes = {
  onAddToCartClick: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default ButtonComponent
